import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import styles from "./Typography.module.scss";

export default function Info(props) {
  const { children } = props;
  return (
    <div className={`${styles.defaultFontStyle} ${styles.infoText}`}>
      {children}
    </div>
  );
}

Info.propTypes = {
  children: PropTypes.node
};
